import React from "react";
import { useCurrency } from "./CurrencyContext";
import { CURRENCIES, Currency } from "./Currencies";

interface CurrencySelectorProps {
  className?: string;
}

const CurrencySelector: React.FC<CurrencySelectorProps> = ({
  className = "",
}) => {
  const { currency, setCurrency } = useCurrency();

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selected = CURRENCIES.find(
      (c) => c.code === e.target.value,
    ) as Currency;
    setCurrency(selected);
  };

  return (
    <select
      className={`language-select ${className}`}
      value={currency.code}
      onChange={handleChange}
      // className={`border rounded px-2 py-1 text-sm ${className}`}
    >
      {CURRENCIES.map((c) => (
        <option key={c.code} value={c.code}>
          {c.symbol} {c.code}
        </option>
      ))}
    </select>
  );
};

export default CurrencySelector;
